import ConfirmModal from '@/_components/ConfirmModal'
import { IRedux } from '@/_store/types'
import { isWorkingHour } from '@/_utils/isWorkingHour'
import { useDisclosure } from '@chakra-ui/react'
import { useTranslations } from 'next-intl'
import React, { useContext, useEffect } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
// import useDelivery from '../../_hooks/useDelivery'
import { Context, TodoContextType } from '@/app/[locale]/(universal)/_checkout/_context'
import { useActiveBrand } from '@/_hooks/useActiveBrand'

export default function OffHoursModal({ onPreorder = () => {} }) {
  const { hasActiveBranch, isOffHours, setOffHours } =
    useContext<TodoContextType>(Context)

  const { order_type, common, future_time, settings } = useSelector(
    (state: IRedux) => ({
      order_type: state.session?.order_type,
      common: state.common,
      future_time: state.checkout?.future_time,
      settings: state.settings,
    }),
    shallowEqual
  )

  const shipperId = useActiveBrand()
  const storeBranch = common?.branches?.[shipperId]

  const { open, onOpen, onClose } = useDisclosure()
  const t = useTranslations()

  const showPreorder =
    settings?.data?.data?.show_preorder ||
    typeof settings?.data?.data?.show_preorder == 'undefined'

  useEffect(() => {
    if (!open) {
      if (storeBranch?.work_hour_start && storeBranch?.work_hour_end) {
        if (
          !future_time &&
          !isWorkingHour(
            storeBranch?.work_hour_start,
            storeBranch?.work_hour_end
          ) &&
          !storeBranch?.is_work_24_7
        ) {
          onOpen()
        }
      } else if (!hasActiveBranch) {
        onOpen()
      }
    }
  }, [storeBranch, future_time, order_type?.id, hasActiveBranch])

  useEffect(() => {
    if (!open && isOffHours && !future_time) {
      console.log('open modal')

      onOpen()
    }
  }, [isOffHours, open])

  return (
    <ConfirmModal
      isOpen={open && !Boolean(future_time) && !Boolean(common.orderIds)}
      onConfirm={onPreorder}
      title={t('attention')}
      onClose={() => {
        onClose()
        setOffHours(false)
      }}
      description={
        t('we_are_currently_closed') +
        ' ' +
        (showPreorder ? t('do_you_preorder') : '')
      }
    />
  )
}
